import {fonts} from '../../../theme/foundations/fonts'
import sizes from '../../../theme/foundations/sizes'
import {pxToRem} from '../../../utills/pxToRem'

export const PromotionsStyle = {
    '.promotions-container': {
        margin: `${pxToRem(24)} ${pxToRem(15)}`,
        color: 'cav_light_black',
        fontFamily: fonts.primary,
        img: {
            margin: '0 auto'
        },

        h1: {
            fontSize: pxToRem(36),
            marginBottom: pxToRem(14),

            [`@media (max-width: ${sizes.container.md})`]: {
                margin: `${pxToRem(10)} 0`
            }
        },
        h2: {
            fontSize: pxToRem(40),
            margin: `${pxToRem(12)} 0`,
            [`@media (max-width: ${sizes.container.md})`]: {
                margin: `${pxToRem(24)} 0`
            }
        },
        p: {
            margin: `${pxToRem(12)} 0`,
            fontSize: pxToRem(12),
            textAlign: 'center'
        },
        a: {
            color: 'black',
            outline: 'medium none',
            overflow: 'hidden',
            cursour: 'pointer',
            textDecoration: 'none',
            background: 'transparent'
        },
        'a:hover': {
            color: 'cav_hover_brightred',
            outline: '0',
            textDecoration: 'nore'
        },
        'a.button': {
            padding: `0 ${pxToRem(42)}`,
            lineHeight: pxToRem(44),
            minWidth: pxToRem(200),
            backgroundColor: 'cav_dark_red',
            colorColor: 'transparent',
            color: 'cav_deep_light_gray',
            transition: 'all 0.3s ease',
            textAlign: 'center',
            fontWeight: 700,
            margin: pxToRem(10),
            fontSize: pxToRem(14)
        },
        'a.button:hover': {
            backgroundColor: 'cav_hover_brightred'
        },
        hr: {
            margin: `${pxToRem(48)} 0`,
            display: 'block',
            marginInlineEnd: 'auto',
            unicodeBidi: 'isolate',
            overflow: 'hidden',
            borderStyle: 'inset',
            borderWidth: pxToRem(1),
            boxSizing: 'content-box',
            bordercolor: 'cav_light_black',
            opacity: '.5',
            height: 0
        },
        '.button-container': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            [`@media (max-width: ${sizes.container.sm})`]: {
                flexDirection: 'column',
                alignItems: 'center'
            },
            a: {
                minWidth: pxToRem(264),
                [`@media (max-width: ${sizes.container.sm})`]: {
                    width: 'fit-content'
                }
            }
        },
        '.block-container': {
            textAlign: 'center',
            margin: 'auto',
            maxWidth: pxToRem(900),
            width: '90%'
        },
        '.full-block-container': {
            textAlign: 'center',
            margin: 'auto',
            width: '100%',
            maxWidth: pxToRem(900)
        }
    }
}
